/* eslint-disable max-len */
import React, { SVGProps } from 'react';

export const DeleteSensorsIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="14"
		height="16"
		viewBox="0 0 14 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M8.41667 0.916687H5.58333C5.39547 0.916687 5.2153 0.991315 5.08247 1.12415C4.94963 1.25699 4.875 1.43716 4.875 1.62502V2.33335H1.33333C1.14547 2.33335 0.965304 2.40798 0.832466 2.54082C0.699628 2.67366 0.625 2.85383 0.625 3.04169C0.625 3.22955 0.699628 3.40972 0.832466 3.54255C0.965304 3.67539 1.14547 3.75002 1.33333 3.75002H2.04167V14.375C2.04167 14.5629 2.11629 14.743 2.24913 14.8759C2.38197 15.0087 2.56214 15.0834 2.75 15.0834H11.25C11.4379 15.0834 11.618 15.0087 11.7509 14.8759C11.8837 14.743 11.9583 14.5629 11.9583 14.375V3.75002H12.6667C12.8545 3.75002 13.0347 3.67539 13.1675 3.54255C13.3004 3.40972 13.375 3.22955 13.375 3.04169C13.375 2.85383 13.3004 2.67366 13.1675 2.54082C13.0347 2.40798 12.8545 2.33335 12.6667 2.33335H9.125V1.62502C9.125 1.43716 9.05037 1.25699 8.91753 1.12415C8.7847 0.991315 8.60453 0.916687 8.41667 0.916687ZM10.5417 13.6667H3.45833V3.75002H10.5417V13.6667Z"
			fill="#768D95"
		/>
		<path
			d="M5.58333 5.16669C5.39547 5.16669 5.2153 5.24131 5.08247 5.37415C4.94963 5.50699 4.875 5.68716 4.875 5.87502V11.5417C4.875 11.7295 4.94963 11.9097 5.08247 12.0426C5.2153 12.1754 5.39547 12.25 5.58333 12.25C5.77119 12.25 5.95136 12.1754 6.0842 12.0426C6.21704 11.9097 6.29166 11.7295 6.29166 11.5417V5.87502C6.29166 5.68716 6.21704 5.50699 6.0842 5.37415C5.95136 5.24131 5.77119 5.16669 5.58333 5.16669Z"
			fill="#768D95"
		/>
		<path
			d="M7.70837 5.87502V11.5417C7.70837 11.7295 7.783 11.9097 7.91584 12.0426C8.04868 12.1754 8.22885 12.25 8.41671 12.25C8.60457 12.25 8.78474 12.1754 8.91757 12.0426C9.05041 11.9097 9.12504 11.7295 9.12504 11.5417V5.87502C9.12504 5.68716 9.05041 5.50699 8.91757 5.37415C8.78474 5.24131 8.60457 5.16669 8.41671 5.16669C8.22885 5.16669 8.04868 5.24131 7.91584 5.37415C7.783 5.50699 7.70837 5.68716 7.70837 5.87502Z"
			fill="#768D95"
		/>
	</svg>
);
